export const ColorPallet = {
  borderColor: "rgba(221, 221, 221, 1)",
  tableRowBorderColor: "#DDDDDD",
  bgcolor: "#FFFFFF",
  tableHeaderColor: "#F0F1F5",

  // As per UI design (mid-Dec 2024)
  neutralWhite: "#FFFFFF",
  neutralLightGrey: "#F0F1F5",
  neutralGrey: "#CCCCCC",
  neutralDarkGrey: "#565c63",
  neutralBlack: "#20272e",
  neutralLightWhite: "#eeeeee",

  primaryBlue: "#0055A8",
  primaryRed: "#D8352C",
  primaryDarkBlue: "#0B2238",
  primaryGrey: "#333333",

  accentBlueUpcoming: "#00A1F1",
  accentLightBlue: "#ddedf5",
  accentInProgress: "#bbb500",
  accentLightInProgress: "#f0ebdd",
  accentWarning: "#eec122",
  accentCompleteSuccess: "#00BB8C",
  accentLightTurquoise: "#D9FFF5",
  accentLightYellow: "#fff5dc",
  accentLightPurple: "#eeeaff",
  accentLightOrange: "#fde0be",
  accentPurple: "#ab9ffc",
  accentAbsent: "#e22626",

  errorText: "#EF4444"
};

export const ColorOpen = {
  bgColor: "#DDEDF5",
  textColor: "#00A1F1",
};

export const ColorAbsent = {
  bgColor: "#C3224842",
  textColor: "#C32248",
};

export const ColorCompleted = {
  bgColor: "#DDF0EB",
  textColor: "#00BB8C",
};

export const ColorProgress = {
  bgColor: "#F0EBDD",
  textColor: "#BBB500",
};

export const TypographyPallet = {
  body1: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "14px",
    color: "#686868",
  },
  body2: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16.8px",
    color: "#686868",
  },
  body3: {
    fontSize: "22px",
    fontWeight: 600,
    lineHeight: "28px",
    color: "#686868",
  },
  body4: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "28px",
    color: "#686868",
  },
  pincss: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    color: "#465668",
  },
  tabcolor: {
    fontSize: "13px",
    fontWeight: 500,
    lineHeight: "19.5px",
    color: "#46566854",
  },
};

export const TypographyActive = {
  body1: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "22px",
    color: "#01A768",
  },
  body2: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "22px",
    color: "#CC9A18",
  },
  progress: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "22px",
    color: "#CC9A18",
  },
};
